import { render, staticRenderFns } from "./ClientsStatisticFilters.vue?vue&type=template&id=0571a4ba&scoped=true"
import script from "./ClientsStatisticFilters.vue?vue&type=script&lang=js"
export * from "./ClientsStatisticFilters.vue?vue&type=script&lang=js"
import style0 from "./ClientsStatisticFilters.vue?vue&type=style&index=0&id=0571a4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571a4ba",
  null
  
)

export default component.exports